import React from "react";

import DadosGeraisPropostaSection from "../sections/DadosGeraisPropostaSection";
import EventsSection from "./sections/EventsSection";
import OpinionsSection from "./sections/OpinionsSection";
import { ComponentWrapper, CardWrapper, CardFilled, Card } from "./styled";
import { Label } from "../styles";
import { toUpper } from "lodash";
import { RejectionReasonsSection } from "./sections/RejectionReasonsSection";
import InformacoesCreditoSection from "../sections/InformacoesCreditoSection";

const AnaliseCreditoComponent = (props) => {
  const {
    cpfCnpj,
    proposalNumber,
    proposalCompleteRegistration = {},
    proposalCompleteRegistrationLoading,
    proposalOperation = {},
    proposalOperationLoading,
    proposalInfoWarranty = {},
    events,
    eventsLoading,
    opinions,
    opinionsLoading,
    eventTypes,
    eventTypesLoading,
    proposalPossibleStatuses,
    proposalPossibleStatusesLoading = [],
    opinionTypes,
    opinionTypesLoading,
    reloadEvents,
    reloadOpinions,
    reloadProposalPossibleStatuses,
    rejectionOpinions,
  } = props;

  return (
    <ComponentWrapper>
      <CardWrapper>
        <Label>Dados gerais da proposta</Label>
        <CardFilled>
          <DadosGeraisPropostaSection
            proposalCompleteRegistrationLoading={
              proposalCompleteRegistrationLoading
            }
            proposalOperationLoading={proposalOperationLoading}
            numeroCpfCnpj={proposalCompleteRegistration.cpfCnpj}
            nomeCliente={proposalCompleteRegistration.nomeCliente}
            nomeConvenio={proposalCompleteRegistration.nomeConvenio}
            nomeFilial={proposalCompleteRegistration.nomeFilial}
            nomeFilialFantasia={proposalCompleteRegistration.nomeFilialFantasia}
            numeroProposta={proposalCompleteRegistration.numeroProposta}
            produto={proposalOperation.produto}
            nomeAnalista={proposalCompleteRegistration.nomeAnalista}
            descricaoStatus={proposalCompleteRegistration.descricaoStatus}
            rankingRelacionamento={
              proposalCompleteRegistration.rankingRelacionamento
            }
            sistemaOrigem={proposalCompleteRegistration.sistemaOrigem}
            pcLtvRisco={proposalCompleteRegistration.pcLtvRisco}
            pcCompRendaCliente={proposalCompleteRegistration.pcCompRendaCliente}
            idRiscoScrCliente={proposalCompleteRegistration.idRiscoScrCliente}
            idRiscoSerasaCliente={
              proposalCompleteRegistration.idRiscoSerasaCliente
            }
          />
        </CardFilled>
      </CardWrapper>

      <CardWrapper>
        <Label>Informações de crédito</Label>
        <Card>
          <InformacoesCreditoSection
            proposalOperationLoading={proposalOperationLoading}
            valorGarantia={proposalInfoWarranty.valorGarantia}
            percentualGarantia={proposalInfoWarranty.percentualGarantia}
            comprometimentoRenda={proposalOperation.comprometimentoRenda}
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>
          Eventos da{" "}
          {toUpper(proposalCompleteRegistration.tipoPessoa) === "F"
            ? "pessoa"
            : "empresa"}
        </Label>
        <Card>
          <EventsSection
            cpfCnpj={cpfCnpj}
            events={events}
            eventsLoading={eventsLoading}
            eventTypes={eventTypes}
            eventTypesLoading={eventTypesLoading}
            reloadEvents={reloadEvents}
          />
        </Card>
      </CardWrapper>

      <CardWrapper>
        <Label>Parecer</Label>
        <Card>
          <OpinionsSection
            cpfCnpj={cpfCnpj}
            proposalNumber={proposalNumber}
            opinions={opinions}
            opinionsLoading={opinionsLoading}
            opinionTypes={opinionTypes}
            opinionTypesLoading={opinionTypesLoading}
            proposalPossibleStatuses={proposalPossibleStatuses}
            proposalPossibleStatusesLoading={proposalPossibleStatusesLoading}
            reloadOpinions={reloadOpinions}
            reloadEvents={reloadEvents}
            reloadProposalPossibleStatuses={reloadProposalPossibleStatuses}
            cpfAnalista={proposalCompleteRegistration.cpfAnalista}
            proposalGroupCode={proposalCompleteRegistration.codigoCarteira}
          />
        </Card>
      </CardWrapper>
      <CardWrapper>
        <Label>Motivos de Rejeição e Contrapartidas</Label>
        <RejectionReasonsSection opinions={rejectionOpinions} />
      </CardWrapper>
    </ComponentWrapper>
  );
};

export default AnaliseCreditoComponent;
